import store from "@/store";

const state = () => ({
  id: '',
  locale: '',
  firstName: '',
  lastName: '',
  username: '',
  phone: '',
  email: '',
  emailVerified: '',
  avatar: '',
  gender: '',
  //
  companyName: '',
  companyRole: '',
  subscriptionType: '',
  subscriptionEndDate: '',
  userRoles: ['Admin'], //заглушка для админки
})

const mutations = {
  set(state, user) {
    state = Object.assign(state, user)
  },
}

const getters = {
  get: (state) => {
    return state
  },
  isAdmin: (state) => {
    return state.userRoles && state.userRoles.length && state.userRoles.includes('Admin')
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
